<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('setSecretQuestionTitleReg')"
            :text="$ml.get('setSecretQuestionTextReg')"
            :action="nextScreen"
            :buttonText="$ml.get('setSecretQuestionButtonReg')"
            :titleH1="false"
            :headerImg="7"
    >
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import Profile from "../../helpers/profile";
    export default {
        name: "infoSecretQuestionPage",
        components: {InfoScreen},
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'login')
                    this.$router.replace('/login/setSecretQuestion');
                else if (Profile.process === 'accessRecovery')
                    this.$router.replace('/accessRecovery/setSecretQuestion');
                else
                    this.$router.replace({ name: 'RegistrationSetSecretQuestion'});
            }
        },
        methods: {
            nextScreen: function () {
                if (Profile.process === 'login')
                    this.$router.push('/login/setSecretQuestion');
                else if (Profile.process === 'accessRecovery')
                    this.$router.push('/accessRecovery/setSecretQuestion');
                else
                    this.$router.push({ name: 'RegistrationSetSecretQuestion'});
            }
        }
    }
</script>

<style scoped>

</style>